<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">

      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <fa-icon [icon]="['fas', 'users']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
            {{ 'group.manage-title' | translate }}
          </div>
          <a routerLink="/borgenar/start" class="btn btn-sm btn-blue text-bold">
            <fa-icon [icon]="['fas', 'arrow-left']" class="me-1"></fa-icon>
            {{ 'button.back' | translate }}
          </a>
        </div>

        <div class="card-body">

          <p class="page-subtitle mb-4">{{ 'group.manage-subtitle' | translate }}</p>

          <h6 class="section-title">
            <fa-icon [icon]="['fas', 'user-plus']" class="me-2"></fa-icon>
            {{ 'group.invite-section-title' | translate }}
          </h6>
          <form [formGroup]="inviteForm" (ngSubmit)="sendInvite()" class="mb-2">
            <div class="row g-2 align-items-start">
              <div class="col-12 col-md-8 mb-0">
                <label for="inviteEmail">{{ 'label.epost' | translate }}</label>
                <input id="inviteEmail" type="email" class="form-control"
                  formControlName="email" placeholder="" autocomplete="off" />
                  @if (inviteForm.get('email')?.touched && inviteForm.get('email')?.invalid) {
                    <small class="text-danger"
                      >
                      {{ 'group.invite-email-invalid' | translate }}
                    </small>
                  }
                </div>
                <div class="col-12 col-md-4 mb-0">
                  <label class="invisible">{{ 'button.search' | translate }}</label>

                  <button class="btn-garanti btn-blue w-100" type="submit" [disabled]="isSending || inviteForm.invalid">
                    <fa-icon [icon]="['fas', 'paper-plane']" class="me-1"></fa-icon>
                    {{ (isSending ? 'group.invite-sending' : 'group.invite-button') | translate }}
                  </button>

                  <div class="validation-space"></div>
                </div>
              </div>
              @if (inviteSent) {
                <div class="mt-2 text-success">
                  <fa-icon [icon]="['fas', 'check-circle']" class="me-1"></fa-icon>
                  {{ 'group.invite-sent' | translate }}
                </div>
              }
            </form>

            @if (isLoading) {
              <div class="text-center py-4">
                <fa-icon [icon]="['fas', 'spinner']" animation="spin" size="lg"></fa-icon>
              </div>
            }

            @if (!isLoading) {
              <hr class="section-divider">
              <h6 class="section-title">
                <fa-icon [icon]="['fas', 'users']" class="me-2"></fa-icon>
                {{ 'group.members-section-title' | translate }}
                <span class="badge text-bg-secondary ms-2">{{ group?.members?.length ?? 0 }}</span>
              </h6>
              @if (!group?.members?.length) {
                <div class="text-muted mb-3">
                  {{ 'group.members-empty' | translate }}
                </div>
              }
              @if (group?.members?.length) {
                <ul class="member-list mb-0">
                  @for (m of sortedMembers; track m) {
                    <li class="member-item">
                      <div class="member-info">
                        <fa-icon [icon]="['fas', 'user']" class="me-2 text-muted member-icon"></fa-icon>
                        <div>
                          <strong>{{ m.fullName }}</strong>
                          @if (m.isCurrentUser) {
                            <span class="badge text-bg-primary ms-2">{{ 'group.you-label' | translate }}</span>
                          }
                          <div class="text-muted member-meta">
                            {{ 'group.member-joined' | translate: { date: (m.joinedUtc | localizeddate:'yyyy-MM-dd') } }}
                            @if (m.invitedByName) {
                              <span> {{ 'group.member-invited-by' | translate: { name: m.invitedByName } }}</span>
                            }
                          </div>
                        </div>
                      </div>
                      <button class="btn btn-sm btn-outline-danger"
                        (click)="removeMember(m.userId, m.fullName, m.isCurrentUser)"
                        [disabled]="m.isCurrentUser && isOpeningTransferModal"
                        [title]="m.isCurrentUser ? ('group.member-leave-title' | translate) : ('group.member-remove-title' | translate)">
                        <fa-icon [icon]="['fas', 'user-minus']"></fa-icon>
                      </button>
                    </li>
                  }
                </ul>
              }
              @if (group?.pendingInvitations?.length) {
                <hr class="section-divider">
                <h6 class="section-title">
                  <fa-icon [icon]="['fas', 'envelope']" class="me-2"></fa-icon>
                  {{ 'group.pending-section-title' | translate }}
                  <span class="badge text-bg-warning ms-2">{{ group.pendingInvitations.length }}</span>
                </h6>
                <ul class="member-list mb-0">
                  @for (inv of group.pendingInvitations; track inv) {
                    <li class="member-item">
                      <div class="member-info">
                        <fa-icon [icon]="['fas', 'envelope']" class="me-2 text-muted member-icon"></fa-icon>
                        <div>
                          <strong>{{ inv.email }}</strong>
                          <div class="text-muted member-meta">
                            {{ 'group.invitation-sent-by' | translate: { date: (inv.createdUtc | localizeddate:'yyyy-MM-dd'), name: inv.invitedByName } }}
                            · {{ 'group.invitation-expires' | translate: { date: (inv.expiresUtc | localizeddate:'yyyy-MM-dd') } }}
                          </div>
                        </div>
                      </div>
                      <button class="btn btn-sm btn-outline-secondary"
                        (click)="revokeInvitation(inv.id)" [title]="'group.modal-revoke-title' | translate">
                        <fa-icon [icon]="['fas', 'times-circle']"></fa-icon>
                      </button>
                    </li>
                  }
                </ul>
              }
            }

          </div>
        </div>

        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'history']" class="me-2"></fa-icon>
            {{ 'group.audit-title' | translate }}
          </div>
          <div class="card-body">

            <div class="audit-toolbar">
              <div class="audit-search-wrap">
                <fa-icon [icon]="['fas', 'search']" class="audit-search-icon"></fa-icon>
                <input type="text" class="form-control audit-search-input"
                  [placeholder]="'group.audit-search-placeholder' | translate"
                  [attr.aria-label]="'group.audit-search-label' | translate"
                  [value]="auditLogSearch"
                  (input)="onAuditSearchChange($any($event.target).value)">
                </div>
                <select class="form-control audit-filter-select"
                  [attr.aria-label]="'group.audit-filter-label' | translate"
                  [value]="auditLogAction"
                  (change)="onAuditActionChange($any($event.target).value)">
                  <option value="">{{ 'group.audit-filter-all' | translate }}</option>
                  <option value="GroupCreated">{{ 'group.action-GroupCreated' | translate }}</option>
                  <option value="MemberJoined">{{ 'group.action-MemberJoined' | translate }}</option>
                  <option value="MemberRemoved">{{ 'group.action-MemberRemoved' | translate }}</option>
                  <option value="MemberLeft">{{ 'group.action-MemberLeft' | translate }}</option>
                  <option value="InviteSent">{{ 'group.action-InviteSent' | translate }}</option>
                  <option value="InviteRevoked">{{ 'group.action-InviteRevoked' | translate }}</option>
                  <option value="CaseTransferred">{{ 'group.action-CaseTransferred' | translate }}</option>
                </select>
              </div>

              @if (isLoadingAuditLog) {
                <div class="text-center py-4">
                  <fa-icon [icon]="['fas', 'spinner']" animation="spin" size="lg"></fa-icon>
                </div>
              }

              @if (!isLoadingAuditLog && !auditLog.length) {
                <div class="audit-empty">
                  <fa-icon [icon]="['fas', 'history']" size="lg" class="mb-2 d-block"></fa-icon>
                  {{ 'group.audit-empty' | translate }}
                </div>
              }

              @if (auditLog.length) {
                <ul class="audit-list">
                  @for (entry of auditLog; track entry; let idx = $index) {
                    @if (auditLogNewBatchStart !== null && idx === auditLogNewBatchStart) {
                      <li class="audit-batch-divider">
                        <span>{{ 'group.audit-batch-separator' | translate }}</span>
                      </li>
                    }
                    <li class="audit-item">
                      <div class="audit-icon" [ngClass]="getAuditIconClass(entry.action)">
                        <fa-icon [icon]="getAuditIcon(entry.action)"></fa-icon>
                      </div>
                      <div class="audit-body">
                        <div class="audit-desc-row">
                          <span class="audit-desc">{{ getAuditDescription(entry) }}</span>
                          @if (isMultiCaseTransfer(entry)) {
                            <button
                              type="button"
                              class="audit-cases-toggle"
                              [attr.aria-label]="(isAuditCasesExpanded(entry.id) ? 'group.audit-cases-hide' : 'group.audit-cases-show') | translate"
                              [title]="(isAuditCasesExpanded(entry.id) ? 'group.audit-cases-hide' : 'group.audit-cases-show') | translate"
                              (click)="toggleAuditCases(entry.id)">
                              <fa-icon [icon]="['fas', isAuditCasesExpanded(entry.id) ? 'chevron-up' : 'chevron-down']"></fa-icon>
                            </button>
                          }
                        </div>
                        @if (isMultiCaseTransfer(entry) && isAuditCasesExpanded(entry.id)) {
                          <ul class="audit-case-names">
                            @for (caseName of getCaseNames(entry); track $index) {
                              <li>{{ caseName }}</li>
                            }
                          </ul>
                        }
                        <span class="audit-time">{{ entry.createdUtc | localizeddate:'yyyy-MM-dd HH:mm' }}</span>
                      </div>
                    </li>
                  }
                </ul>
              }

              @if (auditLogHasMore && !isLoadingAuditLog) {
                <div class="text-center mt-3">
                  <button class="btn btn-sm btn-outline-secondary" (click)="loadMoreAuditLog()">
                    <fa-icon [icon]="['fas', 'chevron-down']" class="me-1"></fa-icon>
                    {{ 'group.audit-load-more' | translate }}
                  </button>
                </div>
              }

            </div>
          </div>

        </div>
      </div>
    </div>
